/**
 * @file Investment Attachment Entity
 * @description TypeScript interfaces for investment file attachments,
 * supporting file storage and text extraction for AI analysis.
 */
/**
 * Allowed MIME types for file uploads
 */
export const ALLOWED_MIME_TYPES = [
    // Documents
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    // Spreadsheets
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
    // Text
    'text/plain',
    // Images (no text extraction)
    'image/png',
    'image/jpeg',
    'image/gif',
];
/**
 * File extension to MIME type mapping
 */
export const FILE_EXTENSION_MIME_MAP = {
    '.pdf': 'application/pdf',
    '.doc': 'application/msword',
    '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    '.xls': 'application/vnd.ms-excel',
    '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    '.csv': 'text/csv',
    '.txt': 'text/plain',
    '.png': 'image/png',
    '.jpg': 'image/jpeg',
    '.jpeg': 'image/jpeg',
    '.gif': 'image/gif',
};
/**
 * Maximum file size in bytes (10MB)
 */
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
/**
 * Maximum extracted text length (100KB)
 */
export const MAX_EXTRACTED_TEXT_LENGTH = 100 * 1024;
//# sourceMappingURL=investment-attachment.js.map